import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Modal.scss';

const Modal = ({ 
  visible, 
  onClose, 
  children, 
  width = 600, 
  height = 'auto',
  className = '',
  closeMaskOnClick = true,
  showCloseButton = true,
  animation = 'zoom',
  duration = 300,
  escapeKey = true
}) => {
  // Create portal target
  const portalTarget = document.body;

  useEffect(() => {
    // Handle ESC key
    const handleEsc = (e) => {
      if (e.keyCode === 27 && onClose && escapeKey) {
        onClose();
      }
    };

    let scrollY = 0;

    if (visible) {
      document.addEventListener('keydown', handleEsc);

      // Save scroll position and lock body
      scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEsc);

      // Restore scroll position
      const savedScrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';

      if (savedScrollY) {
        window.scrollTo(0, parseInt(savedScrollY || '0', 10) * -1);
      }
    };
  }, [visible, onClose, escapeKey]);

  if (!visible) {
    return null;
  }

  const handleMaskClick = (e) => {
    if (e.target === e.currentTarget && closeMaskOnClick && onClose) {
      onClose();
    }
  };

  const modalStyle = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: height !== 'auto' ? (typeof height === 'number' ? `${height}px` : height) : 'auto',
    maxWidth: '95vw',
    maxHeight: '95vh',
    backgroundColor: 'white'
  };

  const modalContent = (
    <div 
      className={`modal-overlay ${animation}`}
      style={{
        animation: visible ? `modal-${animation}-in ${duration}ms ease-out` : `modal-${animation}-out ${duration}ms ease-in`
      }}
      onClick={handleMaskClick}
    >
      <div 
        className={`modal-content ${className}`}
        style={{
          ...modalStyle,
          animation: visible ? `modal-content-${animation}-in ${duration}ms ease-out` : `modal-content-${animation}-out ${duration}ms ease-in`
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {showCloseButton && onClose && (
          <button
            className="modal-close-button"
            onClick={onClose}
            title="Sluiten"
          >
            ×
          </button>
        )}
        {children}
      </div>
    </div>
  );

  return createPortal(modalContent, portalTarget);
};

export default Modal;